import ServiceDocs from 'src/components/ServiceDocs/ServiceDocs';
import { connect } from 'react-redux';
import { VehiclesActionCreator, RepairOrdersActionCreator, FrameworkActionCreator, ROHistoryActionCreator, AppointmentActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    customer: state.Customer.Customer,
    repairOrders: state.RepairOrders,
    loadVin: state.Framework.loadVin,
    loadRO: state.Framework.loadRO,
    specData: state.Specs.specs,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    theme: state.Framework.theme,
    specProfile: state.Framework.specProfile,
    previewFlag: state.Framework.previewFlag,
    store: state.Framework.store,
    branch: state.Framework.branch,
    idmDocs: state.Framework.idmDocs,
    idmFile: state.Framework.idmFile,
    idmFiles: state.Framework.idmFiles,
    osdWebViewFlag: state.Framework.osdWebViewFlag,
    locale: state.Framework.locale,
    miscdec: state.Framework.miscdec,
    identityVerified: state.Customer.identityVerified,
    osdVerifyIdentityFlag: state.Specs.serviceDocsSpecs?.osdVerifyIdentityFlag ?? false,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
});

const mapDispatchToProps = {
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    selectRO: RepairOrdersActionCreator.SelectRO,
    getIDMdoc: FrameworkActionCreator.GetIDMdoc,
    getIDMdocs: FrameworkActionCreator.GetIDMdocs,
    findIDMdocs: FrameworkActionCreator.FindIDMdocs,
    clearIdmFile: FrameworkActionCreator.ClearIdmFile,
    logDocsHistory: RepairOrdersActionCreator.LogDocsHistory,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    getDocsROHistory: ROHistoryActionCreator.GetDocsROHistory,
    onAppCustUpdate: AppointmentActionCreator.UpdateApptCust,
    updateAppVehicle: AppointmentActionCreator.UpdateApptVehicle,
    addCUC: FrameworkActionCreator.AddCUC,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ServiceDocs);